import React, { createContext, useContext } from 'react';

// Create the context
const APIDirectoryHomeContext = createContext();

// Context provider component
export const APIDirectoryHomeContextProvider = ({ children, belongsTo, cartDetails, orderDetails,requestStatus, apiHomeOnClickHandlers, auth }) => {
    return (
        <APIDirectoryHomeContext.Provider value={{ auth, belongsTo, cartDetails, orderDetails, requestStatus, apiHomeOnClickHandlers }}>
            {children}
        </APIDirectoryHomeContext.Provider>
    );
};

// Custom hook to use context in components
export const useAPIDirectoryHomeContext = () => useContext(APIDirectoryHomeContext);